import { withDependencies } from '@wix/thunderbolt-ioc'
import type { ContextProviderRegistry } from './types'

export const BuilderContextProvidersRegistry = withDependencies(
	[],
	(): ContextProviderRegistry => {
		const registry: { [contextType: string]: any } = {}
		return {
			registerContextProvider: (contextType: string, contextProviderModule: any) => {
				registry[contextType] = contextProviderModule
			},
			getContextProvider: (contextType: string) => {
				return registry[contextType]
			}
		}
	}
)
